import helperA11y       from 'shared/mixins/helper-a11y';

/**
 * @module
 * the control the behaviours of a single level of navigation
 */

const selector = '[data-js-card-toprow]';
const cardGridTopRow = function(el, app) {

    const a11yHelper = helperA11y(app);

    const $el = $(el);
    const $parent = $el.parent('.Ge-CardGrid');
    const $children = $el.children();
    const $moreButton = $el.closest('.Ge-CardGrid-Section').find('[data-js-card-more]');
    let   status = false;
    
    const init = function() {
        // reveal the grid
        $parent.addClass('Ge-CardGrid--toprow-ready');
        // init the events
        registerEvents();
        // disable tabbing to all the hidden cards
        a11yUnTabHidden();
    };

    const registerEvents = function() {

        if ($el.closest('.Ge-CardGrid-Section')) {
            if ($moreButton.length) {
                $moreButton.click(function(ev) {
                    ev.preventDefault();
                    $el.trigger('card-toprow-toggle');
                });
            }
        }

        // we're asking to toggle this content
        $el.on('card-toprow-toggle',function(ev) {
            ev.preventDefault();

            // change the toggle status
            if (status) {
                close();
            } else {
                open();
            }
        });

        // if you keyboard focus on a hidden item, open the pile
        $children.on('focus', function(ev) {
            const height = $(this).height();
            if (height === 0) {
                $el.trigger('card-toprow-toggle');
                // and remove the toggle button from keyboard/screenreader
                $moreButton.attr('aria-hidden', true).attr('tabindex', '-1');
            }
        });
    };

    const open = function() {
        $parent.addClass('Ge-CardGrid--toprow-open');
        if ($moreButton.length) {
            $moreButton.addClass('Ge-CardGrid-Buttons-Btn--open')
        }
        a11yTabVisible();
        status = true;
    };
    
    const close = function() {
        $parent.removeClass('Ge-CardGrid--toprow-open');
        if ($moreButton.length) {
            $moreButton.removeClass('Ge-CardGrid-Buttons-Btn--open')
        }
        a11yUnTabHidden();
        status = false;
    };

    // stop tabbing to any hidden cards
    const a11yUnTabHidden = function() {
        $.each($children,function(i, el) {
            if (el.offsetHeight < 2) {
                a11yHelper.hide($(el));
            }
        });
    };

    // allow tabbing to all cards in the list
    const a11yTabVisible = function() {
        a11yHelper.show($children);
    };

    return {
        init: init()
    };
};

cardGridTopRow.selector = selector;

export default cardGridTopRow;
